import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16dbd4ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixedpreview" }
const _hoisted_2 = { class: "fixedpreview2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dataintro" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import {ref, toRefs} from "vue";
import request from "../../../api/index";
import {ElMessage, ElMessageBox} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserimgPreviewer',
  props: {
  datasetName: String,
  datasetId: String,
  datasetIndex:Number,//index of the dataset in showList
  imgList: {
    type: Array,
    default: () => []
  }
},
  emits: ["datasetInDetail", "deleteDataset","modifyDatasetName"],
  setup(__props, { emit: emits }) {

const props = __props;


console.log("props", props);
const dialogVisible = ref(false), newName = ref(props.datasetName);
const showDatasetName = ref(props.datasetName);
const {datasetId} = toRefs(props);

const checkOut = () => {
  console.log(datasetId.value);
  emits("datasetInDetail", datasetId.value);
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { style: {"background":"linear-gradient(transparent, #E7E7E7 100%)"} }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.imgList, (item, index) => {
        return (_openBlock(), _createBlock(_component_el_col, {
          span: 6,
          class: "userblock"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_image, {
                  style: {"width":"100%","height":"100%"},
                  fit: 'fill',
                  class: "image",
                  src: `http://${item.pictureUrl}`
                }, null, 8, ["src"])
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 256)),
      _createVNode(_component_el_col, {
        span: 6,
        class: "userblock"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(showDatasetName.value), 1),
          _hoisted_4,
          _createVNode(_component_el_button, {
            onClick: checkOut,
            type: "success",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("选择")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})